/**
 * An enum of MIME types for different media this application uses.
 *
 * This enum has this name to differentiate it from the deprecated global scope object {@link MimeType},
 * which would make importing this difficult.
 */
export enum Mime {
  Png = "image/png",
  Jpeg = "image/jpeg",

  AudioMp4 = "audio/mp4",
  AudioWebm = "audio/webm",
  Wav = "audio/wav",

  Avi = "video/msvideo",
  VideoMp4 = "video/mp4",
  VideoWebm = "video/webm",

  Plaintext = "text/plain",
}
